import { useEffect } from 'react';

const STORAGE_KEY = 'flowra_branding';

function safeParse(json) {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function applyCssVars(vars) {
  if (!vars || typeof vars !== 'object') return;
  const root = document.documentElement;
  Object.entries(vars).forEach(([key, value]) => {
    if (!key.startsWith('--') || typeof value !== 'string') return;
    root.style.setProperty(key, value);
  });
}

export default function useBranding(tenantId) {
  useEffect(() => {
    document.documentElement.dataset.tenant = tenantId || 'default';

    const stored = localStorage.getItem(STORAGE_KEY);
    const branding = stored ? safeParse(stored) : null;
    if (branding && branding.tenants && tenantId && branding.tenants[tenantId]) {
      applyCssVars(branding.tenants[tenantId]);
    } else if (branding && branding.default) {
      applyCssVars(branding.default);
    }
  }, [tenantId]);
}
